export default "__VITE_ASSET__BRla4a0w__"